import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { getConnectedProviders } from "../../utils/api/aiProviderConfig_apis";
import { shouldShowSectionModelList } from "../../utils/commonfunctions";
import ProviderCard from "./ProviderCard";
import SectionModelList from "./SectionModelList";

export default function LLMConfigurationTabview() {
  const [providers, setProviders] = useState([]);

  const fetchProviders = useCallback(() => {
    return getConnectedProviders().then((res) => {
      const data = res?.data?.data;
      setProviders(Array.isArray(data) ? data : []);
    });
  }, []);

  useEffect(() => {
    fetchProviders();
  }, [fetchProviders]);

  const hasConnectedProvider = shouldShowSectionModelList(providers);
  const connectedProviderSignature = providers
    .filter((p) => p.connected)
    .map((p) => p.key)
    .sort()
    .join(",");

  const confirmSetDefault = async () => {
    try {
      if (!ModelForAction?.id) {
        throw new Error('Model ID is required');
      }

      const response = await setDefaultModel(ModelForAction.id);

      if (response.status === STATUS.SUCCESS) {
        setIsSettingDefault(false);
        showSnackbar(response.message || 'Default AI model set successfully', 'success');
        fetchAIModels();
      } else {
        throw new Error(response.error || 'Failed to set default AI model');
      }
    } catch (error) {
      showSnackbar(error.message || 'Failed to set default AI model', 'error');
      console.error('Error setting default AI model:', error);
    }
  };

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Provider Setup
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Connect at least one provider to unlock Section Model Configuration.
      </Typography>

      <Grid container spacing={1.5}>
        {providers.map((p) => (
          <Grid item xs={12} md={6} key={p.key}>
            <ProviderCard provider={p} onUpdate={fetchProviders} />
          </Grid>
        ))}
      </Grid>

      {hasConnectedProvider ? (
        <>
          <SectionModelList providerSignature={connectedProviderSignature} />
        </>
      ) : null}
    </Box>
  );
}
